import {logNativeFunctionCall, logClickStream} from "./logger";
import { libLogger } from "@vz/react-util";
import util from "./util"

export const nativeHideOrShowBottomNav = (hidetabBar) => {
  if (typeof (tabbar) != "undefined" && tabbar) {    
  var tMsg = { 
    actionType: "updateTab",
    tab: { tabBarHidden: hidetabBar }
   };
  invokeNative(JSON.stringify(tMsg)); 
  }  
};

export const nativeSetTitle = (title, hidetabBar = true, hideCancelInHeaderBar=false)  => {
  /* if (typeof (tabbar) != "undefined" && tabbar) { */
    //alert(title);
    nativeHideOrShowBottomNav(hidetabBar);
    removeChatbotIconOverlap();
    if(title == "Confirmation"){
      crossButton(title); 
    } else{
      if (!hideCancelInHeaderBar){
        nativeSetTitleOnly(title);
      } else {
        removeCancelBridge(title);
      }
    }    
  /* }else{
    nativeSetTitleOnly(title);
  } */  
};

export const nativeShowRatingPrompt = () => {
  var tMsg = { actionType: "showReviewApp"};
  //invokeNative(JSON.stringify(tMsg)); // removing the call as per native request CXTDT-105902
};


export const nativeSetTitleOnly = title => {
  console.log("headerTitle", title);
  var tMsg = { actionType: "setTitle", title: title };
  invokeNative(JSON.stringify(tMsg));
};

export const crossButton = (title, deviceNickName,selectedMdn)  => {
  console.log("headerTitle", title);
  let location = window.location.origin;
  const hostOrigin = window?.reactGlobals?.newL2WebpunchoutUrl
  var tMsg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      title: '',
      backButton: {
        moleculeName: 'navigationImageButton',
        image: 'nav_close',
        action: {
          title: 'Close',
          actionType: 'openPage',
          pageType: 'myPlanIntlAddPlan',
          requestURL : hostOrigin,
          extraParameters: {
            browserUrl: location+"/digital/nsa/secure/ui/intl/"
          },
          analyticsData : {
            "vzwi.mvmapp.LinkName" : "close"
          }
        }
      }
    }
  };
  tMsg.navigationBar.title=title;
  invokeNative(JSON.stringify(tMsg));
};
export const updateNavigation =  (title, status) =>{
  const json = {
      actionType: "updateNavigation",
      navigationBar: {
          moleculeName: "navigationBar",
          title: title,
          alwaysShowBackButton: status
      }
  }
  invokeNative(JSON.stringify(json));
}
export const removeCancelBridge = (title, deviceNickName,selectedMdn) => {
  console.log("headerTitle", title);
  var tMsg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      title: '',
      alwaysShowBackButton: true,
      backButton: {
        moleculeName: 'navigationImageButton',
        image: 'nav_back',
        action: { title: 'back', actionType: 'back', pageType: 'back' },
        accessibilityText: 'Back',
      }
    }
  };
  tMsg.navigationBar.title=title;
  invokeNative(JSON.stringify(tMsg));
};

export const removeChatbotIconOverlap = () => {
  
  var tMsg = {
    actionType: 'updateChatFab',
    chatFab: {
      "hideFabOverlay": true,
      "shouldExpandFab": false
    }
  };
  invokeNative(JSON.stringify(tMsg));
};

export const cancelBridge = (title, deviceNickName, selectedMdn) => {
  console.log("headerTitle", title);

  var tMsg = {
    actionType: 'updateNavigation',
    navigationBar: {
      moleculeName: 'navigationBar',
      title: '',
      alwaysShowBackButton: true,
      backButton: {
        moleculeName: 'navigationImageButton',
        image: 'nav_back',
        action: { title: 'back', actionType: 'back', pageType: 'back' },
        accessibilityText: 'Back',
      },
      additionalRightButtons: [{
        moleculeName: 'navigationLabelButton',
        title: 'Cancel',
        accessibilityText: 'Cancel button',
        action: {
          actionType: 'alert',
          alert: {
            title: ' Are you sure?',
            message: 'Your progress will not be saved for later.',
            alertActions: [{
              title: 'Cancel',
              style: 'default',
              action: {
                actionType: 'cancel'
              }
            },
            {
              title: 'Okay',
              style: 'default',
              action: {
                disabled: false,
                actionType: 'openPage',
                title: 'Okay',
                pageType: 'myPlanIntlAddPlan',
                analyticsData: {
                  "vzwi.mvmapp.LinkName": "cancel"
                }
              }
            }
            ]
          }
        }
      }
      ]
    }
  };

  tMsg.navigationBar.title = title;

  invokeNative(JSON.stringify(tMsg));
};

export const nativeSetError = (errTitle, errMessage) => {
  var errMsg = {};
  errMsg.actionType = "topAlert";
  errMsg.buildNumber = 207;
  errMsg.buttonTitle = "View";
  errMsg.code = "00000";
  errMsg.locale = "en";
  errMsg.message = errMessage;
  errMsg.messageStyle = "TopPersistent";
  errMsg.requestId = "f01926d1-db5f-4035-84d7-2c7eeb4ecd0f";
  errMsg.topMessage = errTitle;
  errMsg.type = "ErrorScreen";
  errMsg.userMessage = errMessage;
  if(errMessage){
    invokeNative(JSON.stringify(errMsg));
  }
};

export const nativeSetBlueAlert = (errTitle, errMessage) => {
  console.log("nativeSetBlueAlert invoked");
  var errMsg = {};
  errMsg.actionType = "topAlert";
  errMsg.buildNumber = 207;
  errMsg.buttonTitle = "View";
  errMsg.code = "00000";
  errMsg.locale = "en";
  //errMsg.message = errMessage;
  errMsg.messageStyle = "Top";
  errMsg.requestId = "f01926d1-db5f-4035-84d7-2c7eeb4ecd0f";
  //errMsg.topMessage = errTitle;
  //errMsg.type = "InfoScreen";
  errMsg.topAlertColor = "#007ab8";
  errMsg.userMessage = errMessage;
  errMsg.newTopAlertStyle = true;
  if(errMessage){
    invokeNative(JSON.stringify(errMsg));
  }
};

export const nativeSetBlueAlertWithAction = (
  msgTitle,
  msgText,
  buttonText,
  actionLink
) => {
  var errMsg = {};
  errMsg.actionType = "topAlert";
  errMsg.buildNumber = 207;
  errMsg.buttonTitle = "View";
  errMsg.code = "00000";
  errMsg.locale = "en";
  errMsg.message = msgText;
  errMsg.messageStyle = "TopPersistent";
  errMsg.requestId = "f01926d1-db5f-4035-84d7-2c7eeb4ecd0f";
  //errMsg.topMessage = msgTitle;
  errMsg.type = "Success";
  errMsg.topAlertColor = "#007ab8";
  errMsg.userMessage = ""; //msgText;
  errMsg.newTopAlertStyle = true;
  errMsg.closeButton = true;
  errMsg.ButtonMap = {};
  errMsg.ButtonMap.appContext = "mobileFirstSS";
  errMsg.ButtonMap.analyticsData = {};
  errMsg.ButtonMap.disableAction = false;
  errMsg.ButtonMap.tryToReplaceFirst = false;
  errMsg.ButtonMap.openInWebview = true;
  errMsg.ButtonMap.actionType = "openURL";
  errMsg.ButtonMap.hideUrl = false;
  errMsg.ButtonMap.pageType = "mixAndMatchExplorePlanSelector";
  errMsg.ButtonMap.presentationStyle = "push";
  errMsg.ButtonMap.title = buttonText;
  errMsg.ButtonMap.isSelected = false;
  errMsg.ButtonMap.selected = false;
  (errMsg.ButtonMap.openOauthWebView = true),
    (errMsg.ButtonMap.customUserAgent = "MY_VZW_APP;IOS13.3;iPhone12,1"),
    (errMsg.ButtonMap.checkCameraPermission = false),
    (errMsg.ButtonMap.showNativeNavigation = true),
    (errMsg.ButtonMap.openInWebview = true),
    (errMsg.ButtonMap.browserUrl = actionLink),
    invokeNative(JSON.stringify(errMsg));
};

export const nativeRedirectToPage = pageType => {
  var pgMsg = {};
  pgMsg.actionType = "openPage";
  pgMsg.title = "Plan";
  pgMsg.presentationStyle = "push";
  pgMsg.tryToReplaceFirst = false;
  pgMsg.disableAction = false;
  pgMsg.pageType = pageType;
  pgMsg.appContext = "mobileFirstSS";
  //pgMsg.requestFrom = "NSAINTL";
  if (pageType === "/feedShopLandingGridwall" || pageType === "feedShopLandingGridwall") {
    pgMsg.extraParameters = {
      "hideFilter": "false",
      "deviceCategoriesToShow": "tablets",
      "title": "Tablets",
      "navigationState": "N=10237",
      "deviceProdId": "",
      "requestFrom": "NSAINTL"
    };
  }
  else if (pageType === "/viewProductList" || pageType === "viewProductList"){
    pgMsg.extraParameters = { "modules": "Entertainment","requestFrom": "NSAINTL" };
  }
  else {
    pgMsg.extraParameters = { requestFrom: "NSAINTL" };
  }
  invokeNative(JSON.stringify(pgMsg));
};

export const nativeRedirectFromLiveTile = (pageType,extraParam, requestParams) => {
  var pgMsg = {};
  pgMsg.actionType = "openPage";
  pgMsg.title = "Plan";
  pgMsg.presentationStyle = "push";
  pgMsg.tryToReplaceFirst = false;
  pgMsg.disableAction = false;
  pgMsg.pageType = pageType;
  pgMsg.appContext = "mobileFirstSS";
  if(extraParam){
    pgMsg.extraParameters = extraParam;
  }
  if(requestParams){
    pgMsg.RequestParams = requestParams;
  }
  invokeNative(JSON.stringify(pgMsg));
};

export const nativeGoBack = pageType => {
  var pgMsg = {};
  pgMsg.actionType = "back";
  pgMsg.presentationStyle = "push";
  pgMsg.tryToReplaceFirst = false;
  pgMsg.disableAction = false;
  //pgMsg.pageType = pageType;
  pgMsg.appContext = "mobileFirstSS";
  pgMsg.extraParameters = { requestFrom: "NSAINTL" };
  invokeNative(JSON.stringify(pgMsg));
};

export const nativeRefreshCache = (refreshType, refresh=false) => {
  var pgMsg = {};
  pgMsg.actionType = "openPage";
  pgMsg.background = true;
  pgMsg.pageType = refreshType;
  pgMsg.appContext = "mobileFirstSS";
  pgMsg.extraParameters = { requestFrom: "NSAINTL" };
  let invokeFunction = false;
  try {
    if(!(typeof mfAppVersion === "undefined" || mfAppVersion === null) && mfAppVersion){
      let appVersion = parseFloat(mfAppVersion);
      if (appVersion >= 6.3) {
        invokeFunction = true;
        // libLogger.logClickStream(appVersion, refreshType, 'CALL-NATIVE-REFRESH');
        // logClickStream(appVersion, refreshType, 'CALL-NATIVE-REFRESH');
      }
    }
  } catch (ex) { }
  if (invokeFunction) {
    invokeNative(JSON.stringify(pgMsg));
  }
};

export const nativeRemoveCaches = () => {
  var pgMsg = {};
  pgMsg.actionType = "removeCaches";  
  pgMsg.removeCaches = { pagesToClear: ["myPlanIntlAddPlan"] };
  let invokeFunction = false;
  try {
    if(!(typeof mfAppVersion === "undefined" || mfAppVersion === null) && mfAppVersion){
      let appVersion = parseFloat(mfAppVersion);
      if (appVersion >= 6.4) {
        invokeFunction = true;
        // libLogger.logClickStream(appVersion, "removeCaches", 'CALL-NATIVE-REMOVE-CACHE');
        // logClickStream(appVersion, "removeCaches", 'CALL-NATIVE-REMOVE-CACHE');
      }
    }
  } catch (ex) { }
  if (invokeFunction) {
    invokeNative(JSON.stringify(pgMsg));
  }
};

export const nativeRedirectToPagePMD = (pageType, mdn, productId, groupId) => {
  var pgMsg = {};
  pgMsg.actionType = "openPage";
  pgMsg.title = "Plan";
  pgMsg.presentationStyle = "push";
  pgMsg.tryToReplaceFirst = false;
  pgMsg.disableAction = false;
  pgMsg.pageType = pageType;
  pgMsg.appContext = "mobileFirstSS";
  //pgMsg.requestFrom = "NSAINTL";
  if (pageType === "feedCheckEligibleLines" || pageType === "/feedCheckEligibleLines"){
    pgMsg.extraParameters = {
      "selectedMdn": "AAL",
      "selectedMTN" : "AAL",
      "deepLink" : true
    } 
  } else {
    pgMsg.extraParameters = {
      "selectedMdn": mdn ? mdn : "",
      "productId": productId ? productId : "",
      "productGroupId": groupId ? groupId : ""      
    } 
  }
    console.log("pageType: "+ pageType + " mdn: "+ mdn + " productId: "+ productId + " groupId: "+ groupId)

  invokeNative(JSON.stringify(pgMsg));
};

export const nativeOpenChat = (pageType) => {
  var pgMsg = {};
  pgMsg.openInWebview = true;
  pgMsg.showNativeNavigation = false;
  pgMsg.tryToReplaceFirst = false;
  pgMsg.extraParameters = {
    "pageType" : "contactUs"     
  } 
  pgMsg.analyticsData = {
    "vzwi.mvmapp.LinkName" : "Chat with us",
    "vzdl.page.linkName" : "Chat with us",
    "multivariateFeedback" : {
      "feedbackEventType" : "chatWithUs_engagement"
    }     
  } 
  pgMsg.title = "Chat with us";
  pgMsg.actionType = "openPanel";
  pgMsg.multivariateFeedbackRequired = true
  pgMsg.presentationStyle = "push";
  pgMsg.pageType = pageType;
  pgMsg.disabled = false;
  pgMsg.openOauthWebView = false;
  pgMsg.panel = "support";
   
  console.log("pageType: "+ pageType)

  invokeNative(JSON.stringify(pgMsg));
};

export const nativeOpenInWebview = browserUrl => {
  var pgMsg = {};
  pgMsg.pageType = "vzwcomSso";
  pgMsg.actionType = "openURL";
  pgMsg.openInWebview = true;
  pgMsg.browserUrl = browserUrl;
  invokeNative(JSON.stringify(pgMsg));
};

export const nativeMaskScreen = (enable) => {
  const isMVM = util.getChannelId() === "VZW-MFA";
  console.log(enable,"nativeMaskScreen enable")
  if(isMVM){
    const args = { "actionType": "fullScreenMasking", enable }
    invokeNative(JSON.stringify(args));
  }
};


var invokeNative = function(msg) {
  console.log("invokeNative called.");
  console.log(msg);
  if(!(typeof _nativeBrdgJson === "undefined" || _nativeBrdgJson === null)){
    _nativeBrdgJson = msg;
  }

  if (window.webkit != undefined) {
    if (window.webkit.messageHandlers.mfAppInterface != undefined) {
      const startTime = Date.now();
      window.webkit.messageHandlers.mfAppInterface.postMessage(msg);
      const executionTime = Date.now() - startTime;
      logNativeFunctionCall(msg, executionTime);
    }
  }
  if (window.mfAppInterface != undefined) {
    const startTime = Date.now();
    window.mfAppInterface.postMessage(msg);
    const executionTime = Date.now() - startTime;
    logNativeFunctionCall(msg, executionTime);
  }
};
